<div class="flex align-items-center justify-content-start gap-2">
  <img *ngIf="img" [src]="img" alt="title icon" height="25" width="auto" />
  <p-button *ngIf="icon" [icon]="icon || ''" class="pointer-events-none"></p-button>
  <span [ngClass]="['text-' + size + ' font-bold']">{{ title }}</span>
</div>
